import {
  ProfileOverviewCardAvatar,
  type ProfileOverviewCardAvatarProps,
} from './avatar';
import {
  ProfileOverviewCardCompatibilityDetails,
  type ProfileOverviewCardCompatibilityDetailsProps,
} from './compatibilityDetails';
import {
  ProfileOverviewCardConnectionInfo,
  type ProfileOverviewCardConnectionInfoProps,
} from './connectionInfo';
import {
  ProfileOverviewCardContainer,
  type ProfileOverviewCardContainerProps,
} from './container';
import {
  ProfileOverviewCardContent,
  type ProfileOverviewCardContentProps,
} from './content';
import {
  ProfileOverviewCardGameInfo,
  type ProfileOverviewCardGameInfoProps,
} from './gameInfo';
import {
  ProfileOverviewCardImageContainer,
  type ProfileOverviewCardImageContainerProps,
} from './imageContainer';
import {
  ProfileOverviewCardImageOverlay,
  type ProfileOverviewCardImageOverlayProps,
} from './imageOverlay';
import type { ProfileOverviewCardMenuProps } from './menu';
import { ProfileOverviewCardMenu } from './menu';
import {
  ProfileOverviewCardRoot,
  type ProfileOverviewCardRootProps,
} from './root';
import {
  ProfileOverviewCardStats,
  type ProfileOverviewCardStatsProps,
} from './stats';

export const ProfileOverviewCard = {
  Root: ProfileOverviewCardRoot,
  Container: ProfileOverviewCardContainer,
  GameInfo: ProfileOverviewCardGameInfo,
  ImageContainer: ProfileOverviewCardImageContainer,
  Avatar: ProfileOverviewCardAvatar,
  ImageOverlay: ProfileOverviewCardImageOverlay,
  Content: ProfileOverviewCardContent,
  Stats: ProfileOverviewCardStats,
  CompatibilityDetails: ProfileOverviewCardCompatibilityDetails,
  ConnectionInfo: ProfileOverviewCardConnectionInfo,
  Menu: ProfileOverviewCardMenu,
} as const;

export type {
  ProfileOverviewCardAvatarProps,
  ProfileOverviewCardCompatibilityDetailsProps,
  ProfileOverviewCardConnectionInfoProps,
  ProfileOverviewCardContainerProps,
  ProfileOverviewCardContentProps,
  ProfileOverviewCardGameInfoProps,
  ProfileOverviewCardImageContainerProps,
  ProfileOverviewCardImageOverlayProps,
  ProfileOverviewCardMenuProps,
  ProfileOverviewCardRootProps,
  ProfileOverviewCardStatsProps,
};
